import React from "react";
import {
  BsFacebook,
  BsInstagram,
  BsMedium,
  BsReddit,
  BsTelegram,
  BsTwitter,
  BsDiscord,
  BsXCircle,
  BsX,
  BsYoutube,
  BsTiktok,
  BsLinkedin,
} from "react-icons/bs";

import { FaXTwitter } from "react-icons/fa6";

import all from "../Assets/All-memes.png";

import "./Footer.css";

export default function Footer() {
  return (
    <div className="main_footer ">
      <div className="container  bord ">
        <div className="footer_content">
          <div style={{ justifyContent: "center", display: "flex" }}>
            <img src={all}></img>
          </div>

          <p style={{ fontSize: "20px" }}>
            Join the presale now and become part of the revolution. With limited
            supply and unlimited ambition, PIKU is ready to electrify your
            portfolio. Don’t miss out—catch PIKU before it’s gone!
          </p>

          <div className="footer_soical_icons">
            <div className="soical-icons d-flex justify-content-center my-3 ">
              <a
                href="https://www.telegram.com//"
                target="_blank"
                className="text-decoration-none"
              >
                <BsTelegram className="sical-logo0"></BsTelegram>
              </a>
              <a
                href="https://twitter.com/"
                target="_blank"
                className="text-decoration-none"
              >
                <FaXTwitter className="sical-logo0"></FaXTwitter>
              </a>
            </div>
          </div>
          <div className="row">
            <p className="copy_right">
              Copyright@2024 : Piku Token all rights reserved
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
